export default function countRulesInGroups(
  promotionConfig: Record<string, any>,
): number {
  const ruleCount =
    promotionConfig?.groups?.reduce(
      (acc: number, group: Record<string, any>) =>
        acc + (group?.rules?.length || 0),
      0,
    ) || 0;
  return ruleCount;
}
